export const exemptAdminAppRoutes: string[] = [
]

export const exemptClientAppRoutes: string[] = [
  'platform'
]

export const exemptAnalystAppRoutes: string[] = [
  'platform/measurement-systems',
  'platform/products',
  'platform/brands',
  'platform/colors',
]

export const exemptProviderAppRoutes: string[] = [
  'platform/users',
  'platform/balances',
  'platform/balances',
  'platform/areas'
]
